import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, tap } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { loadBuildKitDrawings, loadBuildKitDrawingsSuccess, loadBuildKitDrawingsFailure } from '../../../cad-model-upload/state/cad-model-revision-drawing/cad-model-revision-drawing.action';
import { BuildKitService } from '../../data-access/build-kit.service';
import { GetMessage } from '../../../global-config/utils/toast-messages.utils';
import { MessageService, ToastMessageOptions } from 'primeng/api';

@Injectable()
export class BuildKitDrawingEffects {
  loadBuildKitDrawings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBuildKitDrawings),
      switchMap(({ buildKitId }) =>
        this.buildKitService.getDrawings(buildKitId).pipe(
          map(drawings => loadBuildKitDrawingsSuccess({ buildKitId, drawings })),
          catchError(() => of(loadBuildKitDrawingsFailure({ error: GetMessage('LoadFailure', 'Drawings') })))
        )
      )
    )
  );

  toastErrorMessages$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadBuildKitDrawingsFailure),
        tap(({ error }) => {
          return this.messageService.add({
            severity: 'error',
            summary: error,
          } as ToastMessageOptions);
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private buildKitService: BuildKitService,
    private messageService: MessageService,
  ) {}
}
